import React, { Component } from 'react';
import {MasterLayout} from 'layout';
import { Link, browserHistory } from 'react-router';
import { ContainerFileDinhKem } from 'components/upload';
import {Text} from 'components/tt-forms/common';
import DataTable from './datatable/DataTableTTT.jsx';
import { header } from 'constants/table';
import { RowItemChiTietNoiDungTTT } from 'modules/thanh-tra-trung/datatable';
import { ThanhTra } from 'api';
import moment from 'moment';
import { get, isEmpty } from 'lodash';

export default class ChiTietNoiDungXuLy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      tableLoading: false,
      id: this.props.params.id
    }
  }

  componentDidMount() {
    this.getLichSuXuLyCTTTrung();
    this.getChiTietCuocTrung();
  }

  getLichSuXuLyCTTTrung() {
    this.setState({tableLoading: true});
    ThanhTra.actions.getLichSuXuLyCTTTrung.request().then(res => {
      if (res.data._embedded) {
        let lichSuXuLyCTTTrung = res.data._embedded.lichSuXuLyCTTTrungs;
        let dataLichSuXuLyTTT = lichSuXuLyCTTTrung.find(item => {
          if (item.lichSuXuLyCTTId === Number(this.state.id)) {
            return item;
          }
        });
        this.setState({
          ...dataLichSuXuLyTTT,
          tableLoading: false
        });
      }
    });
  }

  getChiTietCuocTrung() {
    this.setState({
      tableLoading: true
    });
    ThanhTra.actions.getLichSuXuLyCTTTrungChiTiet.request({id: this.state.id}).then(res => {
      if (!isEmpty(res.data._embedded)) {
        let dataDetails = get(res, 'data._embedded.medial_CuocThanhTraTrungInfoes');
        this.setState({
          data: dataDetails,
          tableLoading: false
        });
      }
    });
  }

  onClickClose() {
    browserHistory.goBack();
  }

  render() {
    const {lanXuLy, ngayBanHanh, soQuyetDinh, thoiGianXuLy, namThanhTra} = this.state;
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center wrap-block">
          <div className="back-foward">
            <Link onClick={ this.onClickClose.bind(this, 'close') } title="">Về trang trước</Link>
          </div>
          <div className="heading">
            <h2 className="heading-title icon-add">
              Thông tin chi tiết nội dung xử lý
            </h2>
          </div>
          <div className="page-wrapper">
            <div className="box-items mb0">
              <div className="box-forward">
                <div className="title">
                  <div className="rows">
                    <div className="col-12">
                      <h3 className="mb15 tt-title">1. Thông tin xử lý</h3>
                    </div>
                  </div>
                </div>
                <div className="group-box">
                  <div className="items-form mb20">
                    <div className="rows">
                      <Text label='Lần xử lý:' className='col-20' value={lanXuLy}/>
                      <Text label='Số quyết định:' className='col-20' value={soQuyetDinh}/>
                      <Text label='Ngày quyết định:' className='col-20' value={ngayBanHanh ? moment(ngayBanHanh).format('DD/MM/YYYY') : ''}/>
                    </div>
                  </div>
                  <div className="items-form mb20">
                    <div className="rows">
                      <Text label='Năm thanh tra/kiểm tra:' className='col-20' value={namThanhTra}/>
                      <Text label='Thời gian xử lý:' className='col-20' value={moment(thoiGianXuLy).format('DD/MM/YYYY')}/>
                    </div>
                  </div>
                  <div className="items-form mb20">
                    <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription disableAttachFile dataShow={this.state.listTaiLieuVanThus}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-wrapper">
            <div className="title">
              <div className="rows">
                <div className="col-12">
                  <h3 className="mb15 tt-title">2. Nội dung xử lý</h3>
                </div>
              </div>
            </div>
            <div className="ttt-wrapper-table">
                <DataTable
                  onDisableCheck
                  header={header.thanhTraTrung.CNNDXLCT}
                  dataList={this.state.data}
                  thanhTra
                  hidePagination
                  parent={this}
                  search
                  tableLoading={this.state.tableLoading}>
                  <RowItemChiTietNoiDungTTT/>
                </DataTable>
            </div>
          </div>
          <div className="box-bottom ttt-bottom">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
          </div>
        </div>
      </MasterLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/ChiTietNoiDungXuLy.jsx